import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { ILogin } from 'src/app/interfaces/auth.interface';
import { authLogin, authLoginSuccess, getUser } from '../../store/actions/auth.actions';
import { IAppState } from '../../store/app.state';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  formLogin: FormGroup;
  publicUserShow = false;
  privateUser = false;

  formSubmitSubscription = this.actions$.pipe(ofType(authLoginSuccess),
    tap(_ => {
      this.store$.dispatch(getUser());
      this.router.navigate(['/']);
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private store$: Store<IAppState>,
    private actions$: Actions,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.formLogin = this.formBuilder.group({
      usuario: new FormControl(''),
      password: new FormControl(''),
    });
  }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('token');

    if(myParam !== null) {
      this.showResponse1(myParam);
    }
  }

  ngOnDestroy(): void {
    this.formSubmitSubscription.unsubscribe()
  }

  submitForm(): void {
    const form: ILogin = this.formLogin.getRawValue();

    const payload: ILogin = {
      ...form,
    }

    this.store$.dispatch(authLogin({ login: payload }));
  }

  privUser() {
    this.privateUser = !this.privateUser;
  }

  publicUser() {
    this.publicUserShow = true;
  }

  showResponse(event) {
    this.authService.finishPublicLogin('publicToken')
    this.router.navigate(['/instituciones']);
  }

  showResponse1(token) {
    this.authService.finishPublicLogin(token)
    this.router.navigate(['/instituciones']);
  }
}
